import React from 'react';
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormWatch,
} from 'react-hook-form';
import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';
import { FormFieldHeader } from '../../../../components/FormFieldHeader';
import { ReferralKnowledge } from './ReferralConsentKnowledge';
import { ReferralInputData } from './ReferralInputData';
import { ReferralInputHeader } from './ReferralInputHeader';
import { SelectOption } from '../../../../components/Select';

interface PropTypes {
  formControl: Control<CandidateDto, any>;
  hiringMemberOptions: SelectOption[];
  referral?: boolean;
  errors: FieldErrors;
  formRegister: UseFormRegister<CandidateDto>;
  formResetField?: (controllerName: string, options: any) => void;
  watch: UseFormWatch<CandidateDto>;
  getValues: () => CandidateDto;
}

export function ReferralInput(props: PropTypes) {
  if (!props.referral) {
    return null;
  }

  return (
    <>
      <div className='mt-3 border-bottom' />
      <div className='pt-3 pb-3 mb-4'>
        <ReferralInputHeader />
        <ReferralKnowledge formRegister={props.formRegister} />
        <FormFieldHeader
          classNames='mt-4 fs-5 fw-semibold'
          fieldName='Who gets the credit'
          isRequired={true}
        />
        <ReferralInputData {...props} />
      </div>
    </>
  );
}
